var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-language-switch"},_vm._l((_vm.langs),function(lang){return _c('a',{key:lang.value,class:{
      'c-language-switch__lang': true,
      'c-language-switch__lang--selected': lang.value === _vm.$i18n.locale
    },attrs:{"href":"#"},on:{"click":function($event){return _vm.switchLang(lang.value)}}},[_vm._v(" "+_vm._s(lang.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }